import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-import-ewidencji-bledy-modal',
  templateUrl: './import-ewidencji-bledy-modal.component.html',
  styleUrls: ['./import-ewidencji-bledy-modal.component.css']
})
export class ImportEwidencjiBledyModalComponent implements OnInit {

  listaBledow: Array<string> = new Array();

  constructor(
    public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    setTimeout(() => {
    });
  }

}
